import RcTextarea from 'rc-textarea';
import {TextAreaProps} from 'rc-textarea/lib/interface'

const Textarea: React.FC<TextAreaProps> = ({ children, className ,  ...props }) => {
  return <RcTextarea className={`font-[unset] caret-[#4981f2] outline-none ${className}`} {...props}>{children}</RcTextarea>;
};

export default Textarea;
